import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const handleClick = (url: string) => {
    window.open(url, "_blank", "noopener,nofollow");
  };

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="text-xs font-medium text-secondary-600 uppercase tracking-wider">
              Browse Categories
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-1">
              Shop by <span className="text-accent-500">Category</span>
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md">
              Explore our curated collection of fashion, accessories, and lifestyle products
            </p>
          </div>
          <span className="hidden md:inline-block bg-secondary-100 text-secondary-700 text-xs font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
            {categories.length} Categories
          </span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <button
              key={cat.name}
              onClick={() => handleClick(cat.url)}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-4 md:p-5 hover:border-accent-300/60 transition-all text-left cursor-pointer flex flex-col gap-3"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-accent-100 flex items-center justify-center text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div>
                <p className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-foreground-950 whitespace-nowrap transition-colors">
                  {cat.name}
                </p>
                <p className="text-xs text-foreground-400 mt-0.5">
                  View Products <i className="ri-arrow-right-up-line text-[10px]"></i>
                </p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}